<template>
	<core-modal :width="800" name="upgrade-modal" class="upgrade-modal-modal">
		<div class="header">
			<div class="close">
				<svg-times @click="handleClose" />
			</div>
		</div>

		<div class="content">
			<h1>Unlock Access to OptinMonster Pro?</h1>

			<p>The rules used in this Playbook are available with OptinMonster Pro. With Pro, you can...</p>

			<ul>
				<!--eslint-disable vue/singleline-html-element-content-newline -->
				<li v-for="benefit in benefits" :key="benefit"><svg-checkmark /> {{ benefit }}</li>
			</ul>

			<p>Save up to 50% when you upgrade to OptinMonster Pro!</p>

			<a
				ref="button"
				:href="upgradeUrl"
				class="button primary"
				target="_blank"
				rel="noopener noreferrer"
				style="margin: 0 0 15px"
			>
				Unlock Access Now
			</a>

			<button @click="handleContinue()" class="button link-style">
				No thanks, I'll use the Playbook without {{ name }} for now →
			</button>
		</div>
	</core-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	data() {
		return {
			ruleInformation: {
				'exit-intent': {
					friendlyName: 'Exit-Intent',
					benefits: [
						'Stop Abandoning Visitors With Exit Intent',
						'Save Time With Campaign Scheduling',
						'Increase Urgency with Countdown Timers',
						'Pre-Qualify Buyers with Multi-Step Campaigns',
						'Segment Subscribers by Traffic Source',
						'Increase Engagement with MonsterLinks',
						'AND MUCH MORE...',
					],
				},
				'inactivity-time': {
					friendlyName: 'Inactivity Sensor',
					benefits: [
						'Target Distracted Visitors With Inactivity Sensors',
						'Stop Abandoning Visitors With Exit Intent',
						'Save Time With Campaign Scheduling',
						'Increase Urgency with Countdown Timers',
						'Pre-Qualify Buyers with Multi-Step Campaigns',
						'Segment Subscribers by Traffic Source',
						'AND MUCH MORE...',
					],
				},
			},
		};
	},
	computed: {
		...mapState('playbooks', ['upgradeRule']),
		/**
		 * Determine if information exists for the given rule.
		 *
		 * @returns {boolean} true if information exists, false otherwise.
		 */
		hasRuleInfo() {
			return this.upgradeRule && this.ruleInformation[this.upgradeRule] !== undefined;
		},
		/**
		 * Generates the rule's 'friendly' name.
		 *
		 * @returns {string} The rule name to show.
		 */
		name() {
			return this.hasRuleInfo ? this.ruleInformation[this.upgradeRule]['friendlyName'] : '';
		},
		/**
		 * Generates the benefits to show for upgrading
		 *
		 * @returns {Array} The benefits to show
		 */
		benefits() {
			return this.hasRuleInfo ? this.ruleInformation[this.upgradeRule]['benefits'] : [];
		},
		/**
		 * Generates the upgrade URL to use.
		 *
		 * @returns {string} The URL to upgrade.
		 */
		upgradeUrl() {
			return this.$urls.upgrade({ utm_medium: 'Playbooks', feature: this.upgradeRule });
		},
	},
	methods: {
		...mapMutations('playbooks', ['setUpgradeRule']),
		...mapMutations('templates', ['setActiveTemplate']),
		/**
		 * Handles closing the modal.
		 *
		 * @returns {void}
		 */
		handleClose() {
			this.setUpgradeRule('');
			this.setActiveTemplate('');
			this.$modal.hide('upgrade-modal');
		},
		/**
		 * Handles continuing to the campaign creation without upgrading.
		 *
		 * @returns {void}
		 */
		handleContinue() {
			this.$modal.hide('upgrade-modal');
			this.$modal.show('create-campaign-modal');
		},
	},
};
</script>
